import { LiveblocksProvider } from "@liveblocks/react";
import dynamic from "next/dynamic";
import MigrationLoader from "../../ui/loaders/MigrationLoader";
import { LogInFromSpaceButton } from "../../ui/LogInButton";
import { SideNav } from "../../ui/SideNav";
import Space from "../../ui/Space";
import SpaceLoader from "../../ui/SpaceLoader";
import Onboarding from "../../ui/user/Onboarding";
import useLiveblocksClient from "../../utils/useLiveblocksClient";
import useMounted from "../../utils/useMounted";
import { BenchmarkProfiler } from "../../../benchmark/profiler";

const Navigation = dynamic(() => import("../../ui/Navigation"), { ssr: false });

const SpacePage = () => {
  const client = useLiveblocksClient();

  const isMounted = useMounted();
  if (!isMounted) return null;

  return (
    <Onboarding>
      <SideNav />
      <LiveblocksProvider client={client}>
        <SpaceLoader>
          <BenchmarkProfiler>
            <Navigation />
            <MigrationLoader>
              <Space />
            </MigrationLoader>
            <LogInFromSpaceButton />
          </BenchmarkProfiler>
        </SpaceLoader>
      </LiveblocksProvider>
    </Onboarding>
  );
};

export default SpacePage;
